import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import Administration from "../components/Administration/LargeScreenDesign/Administration";
import MobileAdmin from "../components/Administration/SmallScreenDesign/MobileAdmin";
export default function Home() {
  const isMobile = useMediaQuery("(max-width:600px)");

  return <Box>{isMobile ? <MobileAdmin /> : <Administration />}</Box>;
}
